<template>
    <div v-if="showAddAccount" class="containerAddAccount">
        <UseDialog :title="countTitle" :closeCallBack="closeCallBack" width="605" key="addAccount">
            <template #content>
                <div v-loading="loading" class="content">
                    <div class="font14" style="margin-top: 10px;">
                        <span style="color:#e53434;margin-right:5px;">*</span>
                        <span class="coloraea28e">{{l('jyfbsyjm')}}</span>
                    </div>
                    <div class="formDataBox">
                        <template v-if="currentType === 'bankType'">
                            <bankType :currentBank="currentBank" ref="formRef"></bankType>
                        </template>
                        <template v-if="currentType === 'zfbType'">
                            <zfbType :currentBank="currentBank" ref="formRef"></zfbType>
                        </template>
                        <template v-if="currentType === 'usdtType'">
                            <usdtType :currentBank="currentBank" ref="formRef"></usdtType>
                        </template>
                    </div>
                    <div @click="submitBtnFn"
                         class="submitBtn font18 colorfff pointer hover flex alignItemsCenter justifyContentCenter">
                        <span>{{l('qrtj')}}</span>
                    </div>
                </div>
            </template>
        </UseDialog>
    </div>
</template>

<script>
    import {mapState} from "vuex"

    import {addUserBank} from "@/api"

    export default {
        name: "index",
        components: {
            bankType: () => import('./components/bankType.vue'),
            usdtType: () => import('./components/usdtType.vue'),
            zfbType: () => import('./components/zfbType.vue'),
        },
        computed: {
            ...mapState(['showAddAccount', 'userInfo']),
        },
        data() {
            return {
                countTitle: '',
                loading: false,
                scroll: null,   //滚动对象
                currentType: '',
                currentBank: {},
            }
        },
        watch: {
            showAddAccount: {
                handler(newVal, oldVal) {
                    if (newVal) {
                        //动态设置title
                        const _currentBank = JSON.parse(sessionStorage.getItem('currentBank') || '{}')
                        this.currentBank = _currentBank

                        this.countTitle = `${this.l('tj')}${_currentBank?.name || ''}${this.l('zh')}`

                        //计算当前显示什么模板
                        const _type = {
                            '1': 'bankType',    //银行卡
                            '2': 'zfbType',    //支付宝
                            '3': 'zfbType',    //微信
                            '4': 'usdtType',    //usdt
                            '5': 'usdtType',    //EBPAY
                            '6': 'usdtType',    //JDPAY
                            '7': 'usdtType',    //KDPAY
                            '8': 'usdtType',    //CBPAY
                            '9': 'usdtType', //OKPAY
                            '10': 'usdtType', //TOPAY
                        }
                        this.currentType = _type[_currentBank?.id]
                    }
                }, immediate: true
            }
        },
        methods: {
            closeCallBack() {
                this.setStoreState({prop: 'showAddAccount', value: false})
            },
            async submitBtnFn() { //确认添加
                // console.log(this.$refs['formRef'].settlementData());
                const _formData = await this.$refs['formRef'].settlementData()

                const _addUserBankRes = await addUserBank(_formData)
                const _message = _addUserBankRes?.message
                if (_message !== 'success') return

                this.$message.success(this.l('tjzhcg'))
                //关闭当前弹窗
                this.closeCallBack()
            },
        }
    }
</script>

<style lang="scss" scoped>
    .containerAddAccount {
        .content {
            padding: 20px;

            .formDataBox {
                padding: 20px;

                margin-top: 10px;
                background: url("@images/withdrawMoney/qukuan_bg02.png") no-repeat center center/100% 100%;
            }

            .submitBtn {
                height: 50px;
                margin-top: 10px;
                background: url("@images/deposit/ck_ljck.png") no-repeat center center/100% 100%;
            }
        }
    }
</style>
